module.exports = __webpack_public_path__ + "static/media/Turku_logo.1290365a.png";